import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  
  // Get the intended destination if it exists, otherwise default to admin dashboard
  const from = location.state?.from?.pathname || '/admin';

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-skyline-bg">
        <Loader2 className="w-12 h-12 text-skyline-accent animate-spin" />
      </div>
    );
  }

  if (isAuthenticated) {
    // Redirect authenticated users away from public auth pages (like Login)
    // to their intended destination or the default dashboard
    return <Navigate to={from} replace />;
  }

  return children;
};

export default PublicRoute;
